import { SourceProviders } from "../source";
import { convertFromValue } from "../state";
import { formDataToValue, queryDataToValue } from "../data";
import { StepsSourceProvider } from "../source";
import { CallSourceProvider } from "../source";
import { DynamicSourceProvider } from "../source";
import { LiteralSourceProvider } from "../source/LiteralSourceProvider";
const sourceProviders = new SourceProviders()
    .addSourceType(new LiteralSourceProvider())
    .addSourceType(new DynamicSourceProvider())
    .addSourceType(new CallSourceProvider())
    .addSourceType(new StepsSourceProvider());
export class SubmissionValueProvider {
    constructor(submission, providers = sourceProviders) {
        this.submission = submission;
        this.providers = providers;
    }
    setSubmission(submission) {
        this.submission = submission;
    }
    get dumbapp() {
        return this.submission?.dumbapp;
    }
    getAccount() {
        return this.submission?.data?.from;
    }
    getArgValue(arg, step, argNum) {
        if (this.submission) {
            const submittedArgs = this.submission.data.args[step.index];
            let val;
            if (submittedArgs) {
                if (argNum !== null && argNum !== undefined) {
                    val = submittedArgs.args[argNum];
                }
                else if (arg.value) {
                    return this.getSourceValue(arg.value, arg, step);
                }
                if (val !== undefined) {
                    let provider = this;
                    return {
                        async value() {
                            let converted = await convertFromValue(provider, val, arg, step);
                            return converted;
                        },
                    };
                }
            }
            else if (this.submission.dumbapp && arg.value) {
                return this.getSourceValue(arg.value, arg, step);
            }
        }
        return {
            value() {
                return "";
            },
        };
    }
    getInput(name, typing) {
        if (this.submission) {
            for (let values of this.submission.data.inputs) {
                if (values.data[name] !== undefined) {
                    if (values.type === "query") {
                        return queryDataToValue(values.data[name], typing);
                    }
                    else if (values.type === "form") {
                        return formDataToValue(values.data[name], typing);
                    }
                    else {
                        return values.data[name];
                    }
                }
            }
        }
        return undefined;
    }
    getSourceValue(source, arg, step) {
        return this.providers.valueForSource(this, source, arg, step);
    }
}
